import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './site/layout/layout.component';
import { HeaderComponent } from './site/layout/header.component';
import { FooterComponent } from './site/layout/footer.component';
import { SiteComponent } from './site/site.component';
import { MainComponent } from './site/main/main.component';
import { AboutComponent } from './site/about/about.component';
import { ServicesComponent } from './site/services/services.component';
import { NgbModule, NgbSlide, NgbCarousel, NgbCarouselModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxFlickingModule } from '@egjs/ngx-flicking';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SiteService } from './services/site.service';
import { TranslateModule } from '@ngx-translate/core';
import { i18nModule } from './site/i18n';

const routes: Routes = [
    {
        path: '',
        component: SiteComponent,
        children: [
            {
                path: '',
                redirectTo: 'main',
                pathMatch: 'full'
            },
            {
                path: 'main',
                component: MainComponent
            },
            {
                path: 'about',
                component: AboutComponent
            },
            {
                path: 'services',
                component: ServicesComponent
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', useHash: true }),
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgbModule,
        NgxFlickingModule,
        TranslateModule,
        i18nModule
    ],
    declarations: [
        LayoutComponent,
        HeaderComponent,
        FooterComponent,
        SiteComponent,
        MainComponent,
        AboutComponent,
        ServicesComponent
    ],
    providers: [
        SiteService
    ],
    bootstrap: [],
    exports: [RouterModule]
})
export class AppRoutingModule { }
